<template>
    <div
        class="HotGoodFloor_wrap"
        v-if="goodList && goodList.length"
    >
        <Slider
            class="act-slide1"
            style="z-index:999;"
            :autoPlay="isLoop"
            :loop="isLoop"
            :data="goodList"
            :speed="600"
            :showDots="true"
            :slideDots="goodList"
            ref="hotGoodFloor"
        >
            <div
                v-for="(item, index) in goodList"
                :key="index"
                @click="jumpGoodItem(item)"
                :clstag="'jr|keycount|8530052_index_advertisement|'+index"
            ><img
                    :src="item.image"
                    alt=""
                ></div>
        </Slider>
    </div>
</template>

<script>
import Slider from '@/components/Slider.vue';
import { GetSever } from '@/util/sqRequestService';
import { isEmptyObj } from '@/util/common';

let hotPositionCode = 'mxxqsy.index.bklc1';
switch (process.env.VUE_APP_ENV) {
    // case 'dev':
    case 'minner':
        hotPositionCode = 'mxxqpre.index.bklc';
        break;
    case 'dev':
        hotPositionCode = 'mxxqpre.index.bklc';
        break;
    default:
        hotPositionCode = 'mxxqsy.index.bklc1';
        break;
}
export default {
    name: 'HotGoodFloor',
    components: {
        Slider
    },
    data() {
        return {
            isLoop: true,
            goodList: [],
            hotGoodFloorWrapHeight: 0
            // defaultGoodList: [
            //     {
            //         image: 'https://img30.360buyimg.com/cf/jfs/t1/40857/8/14788/60005/5d79b853E762f52f6/8a7686cbf3d95962.jpg',
            //         sortIndex: '1.00',
            //         url: 'https://u.jd.com/Iq4KYj'
            //     }
            // ]
        };
    },
    created() {
        this.getHotGoodList();
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.hotGoodFloorWrapHeight = $('.HotGoodFloor_wrap').height();
            }, 400);
        });
    },
    methods: {
        getHotGoodList() {
            const partParam = {
                positionCode: hotPositionCode
            };
            GetSever('//v-z.jd.com/component/standardInfo.action', partParam).then(res => {
                if (res && !isEmptyObj(res)) {
                    const { data } = res;
                    if (data && !isEmptyObj(data)) {
                        const { slotVoList } = data;
                        if (slotVoList && slotVoList.length) {
                            if (slotVoList.length > 6) {
                                this.goodList = slotVoList.splice(0, 6);
                            } else {
                                this.goodList = slotVoList;
                            }
                        } else {
                            // this.goodList = this.defaultGoodList;
                            this.goodList = [];
                        }
                    }
                } else {
                    this.goodList = [];
                }
            });
        },
        jumpGoodItem(item) {
            if (item.url) {
                window.location.href = item.url;
            }
        }
    }
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';
.HotGoodFloor_wrap {
    padding: 0 $rem32;
    background-color: #ffffff;
}
</style>